// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Categories  (the category directory at /categories)
// The groups of the catch the directory shows and the list view filters by (`?c=<slug>`). Every group is derived from the
// real menu (data/seafood.ts) — its count, cover photo, species and cuts are never typed in here — so it cannot drift from
// the menu. `tile` groups get a card in the directory; the others (shellfish) only appear as filter chips.
// BUSINESS-CONFIGURABLE: which catches belong to which group, the titles and blurbs. A catch may sit in two groups
// (a spiny lobster is both "Crabs & Lobsters" and "Premium"). Keep blurbs to what the menu really offers — no
// "zero formalin", "air-flown" or "live stock" claims.
// ─────────────────────────────────────────────────────────────────────────────
import { seafoodItems, type SeafoodItem } from "./seafood";

export interface CategoryGroup {
  slug: string;
  title: string;
  blurb: string;
  /** Shown as a card in the directory (else the group is only a filter). */
  tile: boolean;
  items: SeafoodItem[];
}

const byIds = (ids: string[]) => seafoodItems.filter((item) => ids.includes(item.id));

export const CATEGORY_GROUPS: CategoryGroup[] = [
  {
    slug: "fish",
    title: "Whole Fish & Steaks",
    blurb: "Kingfish, pomfret, mackerel and more — whole, as steaks or in curry cuts.",
    tile: true,
    items: seafoodItems.filter((item) => item.category === "Fish"),
  },
  { slug: "prawns", title: "Prawns", blurb: "Wild-caught tiger prawns, whole or cleaned & deveined.", tile: true, items: byIds(["tiger-prawns"]) },
  { slug: "crabs-lobsters", title: "Crabs & Lobsters", blurb: "Mud crab and spiny lobster.", tile: true, items: byIds(["mud-crab", "spiny-lobster"]) },
  { slug: "squid", title: "Squid", blurb: "Cleaned whole or cut into rings.", tile: true, items: byIds(["squid"]) },
  {
    slug: "premium",
    title: "Premium Catch",
    blurb: "Limited, higher-value catches.",
    tile: true,
    items: seafoodItems.filter((item) => item.category === "Premium"),
  },
  { slug: "shellfish", title: "Shellfish", blurb: "Prawns, crab and squid.", tile: false, items: seafoodItems.filter((item) => item.category === "Shellfish") },
];
